import React, { Component } from 'react';
import { Modal, Input, Form, Icon, Spin } from 'antd';
import { WhiteSpace } from '../../../../../components/index';
import Api from '../../../../../services/index';
import { CHECK_num_range } from '../../../../../shared/reqexp';
class HammerModal extends Component {
    constructor(props) {
        super(props);
        this.handleOk = () => {
            this.props.form.validateFields((errors, values) => {
                if (!errors) {
                    const { auctionId, roundId } = this.props;
                    const _params = {
                        auctionId,
                        roundId,
                        finalOffer: values.dealPrice,
                    };
                    // 发送应锤价请求
                    this.setState({
                        isShow: true,
                    });
                    // 开始发送请求 显示 正在发送应锤价
                    Api.auction.inquiryPrice(_params).then((_r) => {
                        if (_r) {
                            // 询价成功
                            this.setState({
                                type: 'success',
                            });
                            // 关闭提示
                            setTimeout(() => {
                                this.resetState();
                            }, 1000);
                            this.props.form.resetFields();
                            // 进入应价状态
                            this.props.okClose();
                        }
                        else {
                            // 询价失败
                            this.setState({
                                type: 'error',
                            });
                            // 关闭提示
                            setTimeout(() => {
                                this.resetState();
                            }, 1000);
                        }
                    }).catch((_e) => {
                        console.log('_e');
                        // 询价失败
                        this.setState({
                            type: 'error',
                        });
                        // 关闭提示
                        setTimeout(() => {
                            this.resetState();
                        }, 1000);
                    });
                }
            });
        };
        this.handleCancel = () => {
            this.props.form.resetFields();
            this.resetState();
            this.props.cancelClose();
        };
        this.resetState = () => {
            this.setState({
                isShow: false,
                type: 'loading',
            });
        };
        this.checkSub = (rule, value, callback) => {
            const { nowPrice } = this.props;
            const _v = Number(value) ? Number(value) : 0;
            const _n = Number(nowPrice) ? Number(nowPrice) : 0;
            if (_v <= _n) {
                callback(`应锤价必须高于当前价（${nowPrice}元）`);
            }
            if (_v % 100 !== 0) {
                callback('应锤价必须是整百');
            }
            callback();
        };
        this.state = {
            isShow: false,
            type: 'loading',
        };
    }
    render() {
        const { showCloseModal, nowPrice } = this.props;
        const { getFieldDecorator } = this.props.form;
        const { isShow, type } = this.state;
        return (<React.Fragment>
      <Modal title="输入应锤价" visible={showCloseModal} onOk={this.handleOk} onCancel={this.handleCancel} style={{ position: 'relative' }}>
        <Form labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
            <Form.Item label="应锤价">
                {getFieldDecorator('dealPrice', {
            rules: [{ required: true, message: '请输入应锤价' },
                { pattern: CHECK_num_range(1, 7), message: '请输入正确格式的应锤价' },
                { validator: this.checkSub },
            ],
        })(<Input placeholder={`应锤价必须高于当前价（${nowPrice}元）`}/>)}
            </Form.Item>
        </Form>
        <Tost isShow={isShow} type={type}/>
      </Modal>

      </React.Fragment>);
    }
}
const Hammer = Form.create()(HammerModal);
export default Hammer;
const antIcon = <Icon type="loading" style={{ fontSize: 24, color: '#fff' }} spin/>;
const Tost = (props) => {
    const { isShow, type } = props;
    if (isShow) {
        return (<div className="position__Abs-center" style={{
            width: '176px',
            height: '96px',
            background: 'rgba(0,0,0,0.85)',
            borderRadius: '4px',
        }}>
            <div className="flex__column-center" style={{
            width: '100%',
            height: '100%',
            color: '#fff',
        }}>
                {type === 'loading' &&
            <React.Fragment>
                        <Spin indicator={antIcon}/>
                        <WhiteSpace h={10}/>
                        <div>正在发送应锤价...</div>
                    </React.Fragment>}
                {type === 'success' &&
            <React.Fragment>
                        <div style={{
                width: 24,
                height: 24,
                backgroundColor: '#fff',
                borderRadius: '50%',
            }}>
                            <Icon type="check-circle" theme="filled" style={{ color: '#1dbf6e', fontSize: 24 }}/>
                        </div>
                        <WhiteSpace h={10}/>
                        <div>询价成功！</div>
                    </React.Fragment>}
                {type === 'error' &&
            <React.Fragment>
                        <div style={{
                width: 24,
                height: 24,
                backgroundColor: '#fff',
                borderRadius: '50%',
            }}>
                            <Icon type="close-circle" theme="filled" style={{ color: '#ff4040', fontSize: 24 }}/>
                        </div>
                        <WhiteSpace h={10}/>
                        <div>询价异常</div>
                    </React.Fragment>}
            </div>
        </div>);
    }
    return null;
};
